import { SearchableFilter } from './searchable-filter'

export type CiElement = {
    count: number
    selected: boolean
}

export type CitiesDict = Record<string, CiElement>

export class CitiesFilters extends SearchableFilter {
    selectedCities: Set<string>
    id: string
    title: string
    fuseEngine: any
    viewAllVisible: boolean
    searchableFilter: CitiesDict
    searchedFilter: CitiesDict
    searchValue: string
    getSearchableFilter = () =>
        Object.keys(this.searchedFilter).length > 0
            ? this.searchedFilter
            : this.searchableFilter
    isPanelCollapsed: boolean
    selectAllSelected: boolean

    constructor(data?: any) {
        super()

        this.selectedCities = new Set()
        this.id = 'city'
        this.title = 'region.city.title'
        this.fuseEngine = null
        this.viewAllVisible = true
        this.searchableFilter = data
        this.searchedFilter = data
        this.searchValue = ''
        this.isPanelCollapsed = true
        this.selectAllSelected = false
    }
}
